import { Card, CardContent, CardHeader, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { realtimeDB as db } from "./Firebase/firebase";

const Orders = ({ businessId }) => {

    const [orders, setOrders] = useState({});

    useEffect(() => {
        const fetchData = () => db.ref('orders/').once('value').then((snapshot) => {
                const aOrders = {}
                snapshot.forEach(child => {
                    const data = child.val();
                    if (data.vendor_email === businessId) {
                        if (aOrders[data.order_id]) {
                            aOrders[data.order_id].push(data);
                        } else {
                            aOrders[data.order_id] = [];
                            aOrders[data.order_id].push(data)
                        }
                    }
                });
                setOrders(aOrders);
            })
        fetchData();
    }, []);

    console.log(orders);

    return (
        <Grid container spacing={2}>
            {Object.keys(orders).map((key) => {
                const order = orders[key];
                return(
                    <Grid item xs={12}>
                        <Card
                            style={{
                                backgroundColor: '#fafafa'
                            }}
                        >
                            <CardHeader
                                title={`Order ID: ${key}`}
                            />
                            <CardContent>
                                {order.map((item) => (
                                    <>
                                        <Typography variant="p">Item: {item.product_name}</Typography>
                                        <br/>
                                        <Typography variant="p">Quantity: {item.quantity}</Typography>
                                        <br/>
                                        <Typography variant="p">Product Price: ${item.product_price}</Typography>
                                        <hr style={{ color: 'red' }} />
                                    </>
                                ))}
                                {order.length > 0 && 
                                    <>
                                        <Typography variant="h6">Customer Information</Typography>
                                        <Typography variant="p">Name: {order[0].first_name} {order[0].last_name}</Typography>
                                        <br/>
                                        <Typography variant="p">
                                            Address: {order[0].address}, {order[0].city}, {order[0].state}
                                        </Typography>
                                        
                                    </>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default Orders;